import { useQuery } from "react-query"
import { getItemsReportData } from "./itemsReportApi"

export const useItemsReportDataQuery = (startDate: string, endDate: string) => {
  return useQuery(['items-report', { startDate, endDate }], {
    queryFn: () => getItemsReportData(startDate, endDate),
    refetchOnWindowFocus: false
  })
}